import {
  applyAddGroup,
  doAcceptFriend,
  getIsSelf,
  handleCreateGroupMeeting,
  handleCreateXCMeeting,
  joinGroup,
  launchSession,
  removeFriend,
  startJrtc,
  startVoip
  // handleCreateSingleMeeting
} from "@/components/UserCard/common";
import { AppState } from "@/models";
import { EbookState } from "@/models/ebook";
import { NetState } from "@/models/netStatus";
import ChatState, { UserState } from "@/types/chat/State";
import {
  UserCardAction,
  UserCardActionClickInfo,
  UserCardData,
  UserCardType
} from "@jd/focus-desktop-comps/lib/es/UserCard/UserCardType";
import { UserCardOnFns, UserCardOptions } from "@jd/focus-desktop-comps/lib/es/WebUserCardModal";
import React, { Props, useCallback, useMemo, useState } from "react";
import useShareUserCard from "../useShareUserCard";
import Bus from "@/utils/bus";
import { openCustomUserCardModal } from "@/utils/modals";
import { connect } from "dvajs";
import { applyFriend } from "@/api/ebook";
import clientConfig, { ClientConfigEnum } from "@/config/clientConfig";
import AdministratorModal from "../AdministratorModal";
import { isFocusEnv } from "@/utils";
import config, { ChatConfig, ConfigEnum } from "@/config/config";

type IProps = Readonly<AppState & EbookState & ChatState>;

function useCustomUserCardModal(props: {
  openCreateContactModal?: Function;
  userData: any;
  currentEmployee: any;
  menuList?: [
    "chat", // 聊天
    "voice", // 音频
    "video", // 视频
    "share" // 分享名片
  ];
}) {
  const [voipClick, SetVoipClick] = useState(false);
  const { userData, currentEmployee, openCreateContactModal, menuList } = props;
  const shareUserCard = useShareUserCard({ userData, currentEmployee });
  const [visibleAdministrator, setVisibleAdministrator] = useState({ visible: false, type: "" });

  const actionClick = async (props: UserCardActionClickInfo) => {
    const { type, data, accessPhone, replyMsg } = props;
    openCreateContactModal?.({ visible: false }); // 添加联系人modal关闭
    Bus.emit("onHideUserCenter"); // 系统管理员列表modal关闭
    switch (type) {
      case UserCardAction.Chat:
        launchSession(data, location, history);
        Bus.emit("onHideGlobalSearch");
        return;
      case UserCardAction.Send:
        return await applyFriend(data, accessPhone).then(() => {
          return { close: false, data: true };
        });
      case UserCardAction.Accept:
        return await doAcceptFriend(data, currentEmployee, accessPhone);
      case UserCardAction.AddGroup:
        return await applyAddGroup(data as any, currentEmployee);
      case UserCardAction.JoinGroup:
        return await joinGroup(data as any, currentEmployee, history);
      case UserCardAction.Voip:
        if (voipClick) {
          return;
        }
        SetVoipClick(true);
        setTimeout(() => {
          SetVoipClick(false);
        }, 5000);
        if (clientConfig[ClientConfigEnum.JD_AUDIO]) {
          startJrtc(data, currentEmployee, "voice");
          Bus.emit("onHideGlobalSearch");
          return;
        }
        handleCreateGroupMeeting(data, currentEmployee);
        return;
      case UserCardAction.Jrtc:
        startJrtc(data, currentEmployee);
        Bus.emit("onHideGlobalSearch");
        return;
      case UserCardAction.Meeting:
        handleCreateGroupMeeting(data, currentEmployee);
        Bus.emit("onHideGlobalSearch");
        return;
      case UserCardAction.Share:
        await shareUserCard(data as any);
        return;
      case UserCardAction.XCMeeting:
        await handleCreateXCMeeting(data as any);
        Bus.emit("onHideGlobalSearch");
        return;
      case UserCardAction.Deleted:
        await removeFriend(data, currentEmployee);
        return;
      case UserCardAction.UnitAdministrator:
        (data as any).close();
        doShowAdministrator("unitAdministrator");
        return;
      case UserCardAction.Administrator:
        (data as any).close();
        doShowAdministrator("Administrator");
        return;
      default:
        break;
    }
    // if (isFocusEnv()) {
    //     return { close: true, data: true };
    // }
    // return true;
    return { close: true, data: true };
  };

  const doShowAdministrator = useCallback((type) => {
    setVisibleAdministrator({ visible: true, type });
  }, []);

  const doSwitchAdministrator = useCallback(() => {
    setVisibleAdministrator({
      ...visibleAdministrator,
      visible: false
    });
  }, [visibleAdministrator]);

  const getButtonsList = useCallback(
    (paramProps: any) => {
      const data = paramProps?.data;
      if (!menuList || data?.type === UserCardType.CustomUser) {
        return {
          add: true
        };
      }
      return {
        chat: menuList.includes("chat"),
        voip:
          menuList.includes("voice") &&
          isFocusEnv() &&
          config[ChatConfig.CHAT_SESSION_CREATE_VOIP_ENABLE],
        video: menuList.includes("video") && config[ConfigEnum.CHAT_SESSION_CREATE_JD_VIDEO_ENABLE] && isFocusEnv(),
        webVideo:
          menuList.includes("video") &&
          !isFocusEnv() &&
          config[ConfigEnum.CHAT_SESSION_CREATE_JD_VIDEO_ENABLE],
        share: menuList.includes("share") && getIsSelf(userData, data),
        add: true
      };
    },
    [menuList, userData]
  );

  return {
    AdministratorModal: () =>
      visibleAdministrator.visible ? (
        <AdministratorModal
          visible={visibleAdministrator.visible}
          onCancel={doSwitchAdministrator}
          type={visibleAdministrator.type}
          cardType={UserCardType.CustomUser}
        />
      ) : (
        <div />
      ),
    openCustomUserCardModal: (options: UserCardOptions) => {
      openCustomUserCardModal({ ...options, buttons: getButtonsList(options) }, actionClick);
    }
  };
}

export default useCustomUserCardModal;
